import { render } from "./B2bFilterButtonCentres.vue?vue&type=template&id=3307532b&scoped=true&lang=pug"
import script from "./B2bFilterButtonCentres.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonCentres.vue?vue&type=script&lang=js"

import "./B2bFilterButtonCentres.vue?vue&type=style&index=0&id=3307532b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3307532b"]])

export default __exports__